var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeatilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(340 469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(-340 -469)",
    fill: "#00bf07"
  }), /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-392.557 -462.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M75.446,4.118,71.71.583A2.123,2.123,0,0,0,70.245,0H63.131A2.134,2.134,0,0,0,61,2.131V17.709a2.134,2.134,0,0,0,2.131,2.131h10.85a2.134,2.134,0,0,0,2.131-2.131V5.666a2.14,2.14,0,0,0-.667-1.548Zm-1.129.532H71.424a.194.194,0,0,1-.194-.194V1.73Zm-.336,14.028H63.131a.97.97,0,0,1-.969-.969V2.131a.97.97,0,0,1,.969-.969h6.937V4.456a1.358,1.358,0,0,0,1.356,1.356h3.526v11.9A.97.97,0,0,1,73.982,18.678Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M137.107,200h-8.525a.581.581,0,1,0,0,1.163h8.525a.581.581,0,1,0,0-1.163Z",
    transform: "translate(-64.404 -192.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M137.107,280h-8.525a.581.581,0,1,0,0,1.163h8.525a.581.581,0,1,0,0-1.163Z",
    transform: "translate(-64.404 -269.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M131.4,360h-2.818a.581.581,0,1,0,0,1.163H131.4a.581.581,0,0,0,0-1.163Z",
    transform: "translate(-64.404 -346.049)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeatilIcon);
export default __webpack_public_path__ + "static/media/deatilIcon.132da34fc836eb05883a692759ef508e.svg";
export { ForwardRef as ReactComponent };